import { Spin, Alert } from "antd";
import { useState, useEffect } from "react";
import {
  userGetBooksByTag,
  userGetBooksByCategory,
  userGetBooks,
  userGetSubcriptionPricing,
  userGetBookNewReleases,
  userGetBooksByTags,
  userGetBooksByCategories,
} from "../../apiservice/userService";
import BookSlider from "../BookComponents/BookSlider";
import {
  Cache_Subscription_Plan_Key,
  getPreferredCategories,
  getPreferredTags,
} from "../../utils/apiSample/recommendation";
import { BookSliderSkeleton } from "../BookComponents/BookSkeletonLoading";

const BookDiscoveryPage = () => {
  const [selectedTag, setSelectedTag] = useState<string>("");
  const [bookData, setBookData] = useState<any>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchAllBooks = async () => {
    const preferredCatData = await getPreferredCategories();
    const preferredTagData = await getPreferredTags();

    console.log(preferredCatData, preferredTagData);
    try {
      setLoading(true);
      setError(null);

      // Make all API calls in parallel
      const [
        trendingBooks,
        bestsellers,
        newReleases,
        recommendedBooks,
        businessBooks,
        selfImprovementBooks,
      ] = await Promise.all([
        userGetBooksByTag("trending"),
        userGetBooksByTag("bestseller"),
        userGetBookNewReleases(),
        preferredTagData.length
          ? userGetBooksByTags(preferredTagData)
          : preferredCatData.length
          ? userGetBooksByCategories(preferredCatData)
          : userGetBooks(),
        userGetBooksByCategory("10"),
        userGetBooksByTag("self-improvement"),
      ]);

      setBookData({
        trendingBooks,
        bestsellers,
        newReleases,
        recommendedBooks,
        businessBooks,
        selfImprovementBooks,
      });
    } catch (err) {
      console.error("Error fetching books:", err);
      setError("Failed to load books. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  // Fetch all book data in parallel
  useEffect(() => {
    fetchAllBooks();
  }, []);

  // Prefetch subscriptin Plan and save it before we will request for it.
  const fetchSubscriptionPlan = async () => {
    try {
      const subPlanData = await userGetSubcriptionPricing();
      if (subPlanData) {
        localStorage.setItem(
          Cache_Subscription_Plan_Key,
          JSON.stringify(subPlanData?.data)
        );
      }
    } catch (err) {
      console.log("Failed to load subscriptions plan");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchSubscriptionPlan();
  }, []);

  if (loading) {
    return (
      <div className="container mx-auto p-4">
        <BookSliderSkeleton title="Trending Now" />
        <BookSliderSkeleton title="Bestsellers" />
        <BookSliderSkeleton title="New Releases" />
        <BookSliderSkeleton title="Recommended for you" />
      </div>
    );
  }

  if (error) {
    return (
      <div className="container mx-auto p-4">
        <Alert
          message="Error"
          description={error}
          type="error"
          showIcon
          action={
            <button
              onClick={() => fetchAllBooks()}
              className="px-4 py-2 bg-red-500 text-white rounded hover:bg-red-600"
            >
              Retry
            </button>
          }
        />
      </div>
    );
  }

  if (!bookData) {
    return (
      <div className="container mx-auto p-4">
        <Alert
          message={
            <span className="text-gray-900 dark:text-stone-100">
              No Book is found
            </span>
          }
          description={error}
          type="info"
          showIcon
          action={
            <button
              onClick={() => fetchAllBooks()}
              className="px-4 py-2 bg-red-500 text-white rounded hover:bg-red-600"
            >
              Retry
            </button>
          }
        />
      </div>
    );
  }

  return (
    <div className="container mx-auto p-4">
      {!selectedTag && (
        <>
          {/* Trending Books */}
          <BookSlider
            title="Trending Now"
            books={bookData.trendingBooks?.data}
          />

          {/* Bestsellers */}
          <BookSlider title="Bestsellers" books={bookData.bestsellers?.data} />

          {/* New Releases */}
          <BookSlider title="New Releases" books={bookData.newReleases?.data} />

          {/* Recommended */}
          <BookSlider
            title="Recommended for you"
            books={bookData.recommendedBooks?.data}
          />

          {/* Business Books */}
          <BookSlider
            title="Business & Leadership"
            books={bookData.businessBooks?.data}
          />

          {/* Self-Improvement */}
          <BookSlider
            title="Self-Improvement"
            books={bookData.selfImprovementBooks?.data}
          />
        </>
      )}
    </div>
  );
};

export default BookDiscoveryPage;
